export const ROLE_TYPE = {
  AGENT: 'DAG_AtlasPortalCustomerView',
  AGENT_ADMIN: 'DAG_AtlasPortalAdminView'
} as const;

export type RoleType = (typeof ROLE_TYPE)[keyof typeof ROLE_TYPE];

export const AUTH_TYPE = {
  AGENT: 'agent',
  AUTH: 'auth',
  PASSBACK: 'passback',
  NONE: 'none'
} as const;

export type AuthType = (typeof AUTH_TYPE)[keyof typeof AUTH_TYPE];
